export default __webpack_public_path__ + "assets/5c1def31da31f0ec2fb93811e5772568.jpeg";